<template>
  <v-container>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          v-on="on"
          @click="$router.push(`/`)"
        >
          <v-icon>mdi-puzzle</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("calendar.buttons.gotoModules") }}</span>
    </v-tooltip>
    <v-card class="mt-12 pa-4">
      <v-card-title>{{ $t("calendar.title") }}</v-card-title>
      <v-card-text>
        <form>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                v-model="search"
                :label="$t('calendar.labels.search')"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="equipmentFilter"
                :items="equipments"
                :label="$t('calendar.labels.select')"
                item-text="equipTag"
                item-value="id"
                hide-details="auto"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-checkbox
                v-model="selectedFilters"
                :label="$t('calendar.labels.maintenance')"
                color="yellow"
                value="maintenance"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-checkbox
                v-model="selectedFilters"
                :label="$t('calendar.labels.reliability')"
                color="blue"
                value="reliability"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-checkbox
                v-model="selectedFilters"
                :label="$t('calendar.labels.repair')"
                color="orange"
                value="repair"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-checkbox
                v-model="selectedFilters"
                :label="$t('calendar.labels.onetime')"
                color="secondary"
                value="unique"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-checkbox
                v-model="selectedFilters"
                :label="$t('calendar.labels.recurrent')"
                color="info"
                value="recurrent"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="4" md="4">
              <v-checkbox
                v-model="selectedFilters"
                :label="$t('calendar.labels.future')"
                color="primary"
                value="futuretasks"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-checkbox
                v-model="selectedFilters"
                :label="$t('calendar.labels.old')"
                color="primary"
                value="oldtasks"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
        </form>
      </v-card-text>
    </v-card>
    <v-sheet height="64">
      <v-toolbar class="my-12" flat>
        <v-spacer></v-spacer>
        <v-btn fab text @click="prev">
          <v-icon small>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title class="font-weight-bold text-capitalize">{{
          title
        }}</v-toolbar-title>
        <v-btn fab text @click="next">
          <v-icon small>mdi-chevron-right</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          fab
          absolute
          top
          right
          color="primary"
          dark
          class=""
          @click="dialog = true"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-toolbar>
    </v-sheet>

    <v-calendar
      ref="calendar"
      v-model="focus"
      color="primary"
      :events="filteredListOfEvents"
      :event-color="getEventColor"
      :event-text-color="getEventTextColor"
      :event-margin-bottom="3"
      :now="today"
      type="month"
      @click:event="showEvent"
      @click:more="viewDay"
      @click:date="viewDay"
      @change="updateRange"
      :weekdays="[1, 2, 3, 4, 5, 6, 0]"
      :locale="user && user.language ? user.language : 'en'"
      :short-weekdays="false"
    ></v-calendar>
    <!-- Modal Agregar Evento -->
    <v-dialog v-model="dialog">
      <new-global-event @close="dialog = false"></new-global-event>
    </v-dialog>

    <v-menu
      v-model="selectedOpen"
      :close-on-content-click="false"
      :activator="selectedElement"
      offset-x
    >
      <v-card light min-width="350px" flat>
        <v-toolbar :color="selectedEvent.color">
          <v-btn
            fab
            bottom
            right
            absolute
            dark
            x-small
            color="primary"
            @click.prevent="generateIcs(selectedEvent)"
          >
            <v-icon>mdi-download-outline</v-icon>
          </v-btn>

          <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
          <v-btn icon @click="deleteEvent(selectedEvent)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-form v-if="currentlyEditing !== selectedEvent.id">
            {{ selectedEvent.name }} - {{ selectedEvent.details }}
          </v-form>

          <v-form v-else>
            <v-text-field
              type="text"
              v-model="selectedEvent.name"
              label="Editar Nombre"
            >
            </v-text-field>

            <v-textarea
              v-model="selectedEvent.details"
              type="text"
              style="width: 100%"
              :min-height="100"
            ></v-textarea>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-btn text color="secondary" @click="selectedOpen = false">
            Cancel
          </v-btn>
          <v-btn
            text
            v-if="currentlyEditing !== selectedEvent.id"
            @click.prevent="editEvent(selectedEvent.id)"
            >Editar</v-btn
          >

          <v-btn text v-else @click.prevent="updateEvent(selectedEvent)"
            >Guardar Cambios</v-btn
          >
          <v-btn text @click.prevent="goToTaskProfile(selectedEvent)"
            >Ir al Evento</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-menu>

    <list-of-events
      :events="events"
      :selected-filters="selectedFilters"
      :search="search"
    ></list-of-events>
  </v-container>
</template>

<script>
import ListOfEvents from "./ListOfEvents";
import NewGlobalEvent from "./NewGlobalEvent";
import { mapState, mapGetters } from "vuex";
import { ICalendar } from "datebook";
export default {
  name: "CalendarIndex",
  components: {
    ListOfEvents,
    NewGlobalEvent
  },
  data: () => ({
    today: new Date().toISOString().substr(0, 10),
    focus: new Date().toISOString().substr(0, 10),
    type: "month",
    typeToLabel: {
      month: "Mes",
      week: "Week",
      day: "Day",
      "4day": "4 Days"
    },
    search: "",
    equipmentFilter: "N/A",
    selectedFilters: [
      "repair",
      "maintenance",
      "reliability",
      "unique",
      "recurrent",
      "futuretasks"
    ],
    start: null,
    end: null,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    name: null,
    details: null,
    color: "#1976D2",
    dialog: false,
    currentlyEditing: null
  }),
  computed: {
    equipments() {
      const equipmentsMapped = this.equipmentsList.map(equipment => {
        const { id, equipTag } = equipment;
        return { id, equipTag };
      });
      equipmentsMapped.push({ equipTag: "N/A", id: "N/A" });
      return equipmentsMapped;
    },
    ...mapState("calendar", ["events"]),
    ...mapState("auth", ["user"]),
    ...mapGetters("equipments", ["equipmentsList"]),
    title() {
      const { start, end } = this;
      if (!start || !end) {
        return "";
      }

      const startMonth = this.monthFormatter(start);
      const startYear = start.year;
      return `${startMonth} ${startYear}`;
    },
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: "UTC",
        month: "long"
      });
    },
    listOfEvents() {
      if (this.events) {
        let realEvents = [];
        let totalEvents = [...this.events];
        totalEvents.forEach(event => {
          // Si ya pasó el evento
          let today = new Date();
          today.setHours(0, 0, 0, 0);

          // Si es unico evento
          if (event.type === "unique") {
            const isPast =
              +today > +new Date(event.end) &&
              today.getDate() !== new Date(event.end).getDate();

            const colorText = isPast ? "white" : "black";
            realEvents.push({
              id: event.id,
              name: event.name,
              equipment: event.equipmentProfile,
              color: this.getColor(
                event.type,
                event.subtype,
                event.color,
                isPast
              ),
              colorText,
              details: event.details,
              start: event.start,
              end: event.end,
              link: event.link,
              type: event.type,
              subtype: event.subtype,
              isPast
            });
          }
          // Si es un evento recurrente
          if (event.type === "recurrent") {         

            let timeStart = new Date(event.start+'T00:00');
            let timeEnd = new Date(event.end+'T00:00');
            // time difference counting the first day
            let diffTime = (Math.abs(timeEnd - timeStart)/86400000)+1;
            let eventDuration = diffTime * 24 * 3600 * 1000;
            let finalTime = +timeStart + eventDuration;
            let dateToEvent = +timeStart;
  
            
            while (dateToEvent < finalTime) {
            
              const isPast =
                +today > +new Date(dateToEvent) &&
                today.getDate() !== new Date(dateToEvent).getDate();

              const colorText = isPast ? "white" : "black";
              // Si es evento recurrente con eventos eliminados
              const uniqueId = `${event.id}${dateToEvent}`;
              if (!event.disabledArray?.includes(uniqueId)) {
                realEvents.push({
                  id: event.id,
                  uniqueId,
                  name: event.name,
                  equipment: event.equipmentProfile,
                  color: this.getColor(
                    event.type,
                    event.subtype,
                    event.color,
                    isPast
                  ),
                  colorText,
                  details: event.details,
                  start: dateToEvent,
                  end: dateToEvent,
                  link: event.link,
                  type: event.type,
                  subtype: event.subtype,
                  isPast
                });
              }
              dateToEvent += event.changeTime * 1000;
            }
          }
        });
        return realEvents;
      }
      return [];
    },
    filteredListOfEvents() {
      return this.listOfEvents.filter(event => {
        /*
        id: event.id,
        uniqueId,
        name: event.name,
        color: this.getColor(
          event.type,
          event.subtype,
          event.color,
          isPast
        ),
        colorText,
        details: event.details,
        start: dateToEvent,
        end: dateToEvent,
        link: event.link
        */
        //Equipmen

        const isInEquipment =
          this.equipmentFilter === "N/A"
            ? true
            : this.equipmentFilter === event.equipment?.id;

        // Type, subtype and Equipment
        const isInFilters =
          this.selectedFilters.includes(event.type) &&
          this.selectedFilters.includes(event.subtype);
        // Future and old
        const isInTimeFilter = event.isPast
          ? this.selectedFilters.includes("oldtasks")
          : this.selectedFilters.includes("futuretasks");

        const isInSearch =
          event?.name?.toLowerCase().includes(this.search.toLowerCase()) ||
          event?.subtype?.toLowerCase().includes(this.search.toLowerCase()) ||
          event?.type?.toLowerCase().includes(this.search.toLowerCase()) ||
          event?.details?.toLowerCase().includes(this.search.toLowerCase());

        return isInSearch && isInFilters && isInTimeFilter && isInEquipment;
      });
    }
  },
  mounted() {
    this.$refs.calendar.checkChange();
  },
  created() {
    this.getEvents();
  },
  methods: {
    goToTaskProfile(task) {
      this.$router.push({
        name: "TaskProfile",
        params: {
          id: task.id,
          uniqueId: task.uniqueId ? task.uniqueId : "N/A",
          taskDate: task.taskDate ? task.taskDate : "N/A"
        }
      });
    },
    tryConsole(something) {
      console.log(something);
    },
    getColor(type, subtype, color, isPast) {
      if (type === "unique") return isPast ? "green lighten-4" : "green";
      if (subtype === "maintenance")
        return isPast ? "yellow lighten-4" : "yellow";
      if (subtype === "reliability") return isPast ? "blue lighten-4" : "blue";
      if (subtype === "repair") return isPast ? "orange lighten-4" : "orange";
    },
    generateIcs(item) {
      const config = {
        title: item.name,
        description: item.details,
        start: new Date(`${item.start} EDT`),
        end: new Date(`${item.end} EDT`)
      };
      const icalendar = new ICalendar(config);

      icalendar.download();
    },
    async updateEvent(ev) {
      try {
        const payload = {
          db: "calendar",
          doc: ev.id,
          data: {
            name: ev.name,
            details: ev.details
          }
        };
        await this.$store.dispatch("updateDocument", payload);
        this.selectedOpen = false;
        this.currentlyEditing = null;
      } catch (error) {
        console.error(error);
      }
    },
    editEvent(id) {
      this.currentlyEditing = id;
    },
    async deleteEvent(ev) {
      const res = await this.$dialog.confirm({
        text: "Do you want to Delete this Event?",
        title: "Please Confirm"
      });
      if (res) {
        try {
          await this.$store.dispatch("deleteDocument", {
            db: `calendar`,
            doc: ev.id
          });

          this.selectedOpen = false;
        } catch (error) {
          console.error(error);
        }
      }
    },
    async addEvent() {
      try {
        if (this.name && this.start && this.end) {
          const payload = {
            db: "calendar",
            data: {
              name: this.name,
              details: this.details,
              start: this.start,
              end: this.end,
              color: this.color
            }
          };
          await this.$store.dispatch("addDocument", payload);

          this.name = null;
          this.details = null;
          this.start = null;
          this.end = null;
          this.color = "#1976D2";
        } else {
          this.$dialog.notify.error("Campos Obligatorios", {
            position: "top-right",
            timeout: 5000
          });
        }
      } catch (error) {
        this.$dialog.notify.error(error, {
          position: "top-right",
          timeout: 5000
        });
      }
    },
    async getEvents() {
      await this.$store.dispatch("calendar/bindCalendar");
    },
    goToProfile() {
      this.$router.push({
        path: `/task-profile/${this.selectedEvent.id}`
      });
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    getEventTextColor(event) {
      return event.colorText || "black";
    },
    setToday() {
      this.focus = this.today;
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    updateRange({ start, end }) {
      // You could load events from an outside source (like database) now that we have the start and end dates on the calendar
      this.start = start;
      this.end = end;
    },
    nth(d) {
      return d > 3 && d < 21
        ? "th"
        : ["th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th"][d % 10];
    }
  }
};
</script>
